import { observer } from 'mobx-react-lite';
import { RichTextField, Widget, WidgetProps } from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function DownloadWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  return (
    <Widget surface="gray" title="Download Message" {...rest}>
      <RichTextField
        label="Message"
        name="text"
        onChange={product.extendedFeatures.download.handleChange}
        value={product.extendedFeatures.download.text}
      />
    </Widget>
  );
});
